var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBackIcon11X18 = function SvgBackIcon11X18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-color-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.066 17.556a1.5 1.5 0 0 0 0-2.129l-6.445-6.43 6.445-6.43A1.505 1.505 0 0 0 7.937.438L.444 7.931a1.5 1.5 0 0 0 0 2.127l7.493 7.498a1.5 1.5 0 0 0 2.129 0Z"
  })));
};
export default SvgBackIcon11X18;